import LoopIcon from "@mui/icons-material/Loop";
import { Box, IconButton, Skeleton, useMediaQuery } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Search from "../../../../components/inputs/search";
import { API } from "../../../../scripts/api";
import axiosInstance from "../../../../scripts/axiosInspector";

const Step2 = ({ dataS, setDataS }) => {
  const [data, setData] = useState([]);
  const [Idata, setIData] = useState([]);
  const [hasChecked, setHasChecked] = useState(false);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState("");
  const isMd = useMediaQuery("(min-width:756px)");
  useEffect(() => {
    getData();
  }, []);
  const getData = (search) => {
    setLoading(true);
    axiosInstance
      .get(
        API.info.seller +
          `?guidStateRecNo=${company?.guidRecNo}${
            search ? `&chSearchValue=${search}` : ""
          }`,
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        if (!search && Idata.length === 0) setIData(res?.data?.data);
        setData(res?.data?.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        /*   if (err.response.status === 401 || err.response.status === 403) {
          dispatch(handleLogOut());
        } */
      });
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (userInfo) {
        setLoading(true);
        setHasChecked(false);
        if (searchData && searchData !== "undefined" && !hasChecked) {
          getData(searchData);
        } else {
          setLoading(false);
        }
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [userInfo, searchData, hasChecked]);
  return (
    <div>
      <div className="flex flex-col gap-4 md:grid grid-cols-3 p-2">
        <div className=" col-span-3 ">
          <div className=" border-b pb-2 mb-2  ">
            <div className=" flex items-end justify-between gap-4">
              {" "}
              <div className="flex gap-1 mt-5 items-center">
                <span className="text-sm font-bold text-main">
                  تعداد موارد یافت شده :‌
                </span>
                <span className="text-sm font-bold text-main">
                  {(searchData ? data : Idata)?.length}
                </span>
              </div>
              {isMd && (
                <div className="mt-4">
                  <Search
                    search={searchData}
                    setSearch={(e) => setSearchData(e.target.value)}
                  />
                </div>
              )}
              <IconButton
                onClick={() => getData()}
                sx={{ padding: "0px !important" }}
              >
                <LoopIcon
                  color="primary"
                  sx={{
                    color: (theme) =>
                      theme.palette.mode === "light" ? "" : "#fff  !important",
                  }}
                />
              </IconButton>
            </div>
            {!isMd && (
              <div className="mt-4">
                <Search
                  search={searchData}
                  setSearch={(e) => {
                    setSearchData(e.target.value);
                    setHasChecked(true);
                  }}
                />
              </div>
            )}
          </div>
        </div>
        {loading ? (
          <>
            <Skeleton
              variant="rounded"
              width={"100%"}
              animation="wave"
              height={140}
            />{" "}
            <Skeleton
              variant="rounded"
              width={"100%"}
              animation="wave"
              height={140}
            />{" "}
            <Skeleton
              variant="rounded"
              width={"100%"}
              animation="wave"
              height={140}
            />
          </>
        ) : (
          <>
            {(searchData ? data : Idata)?.map((item, index) => (
              <Fragment key={index}>
                <Box
                  onClick={() =>
                    setDataS({ ...dataS, guidSellerRecNo: item?.guidRecNo })
                  }
                  className={`flex relative z-50 flex-col gap-4 border border-solid p-4 rounded-md ${
                    dataS?.guidSellerRecNo !== item.guidRecNo
                      ? "unSelectedBox"
                      : "selectedBox"
                  }`}
                >
                  <div className="flex items-center gap-4">
                    <span className="text-sm font-bold">
                      {item?.chSaleSoftID}
                    </span>
                    <span className="text-sm font-bold">
                      {item?.chBuyerTypeName}
                    </span>
                  </div>
                  <span className="text-sm font-bold">{item?.chName}</span>
                </Box>
              </Fragment>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default Step2;
